/* Popup de bienvenida con codigo de descuento, y su recordatorio en el carrito.

   La cuenta atras apunta a una fecha real, la misma con la que se creo el codigo
   en Shopify. Pasada esa hora no se muestra nada: un reloj que se reinicia con
   cada visita mientras el codigo sigue vivo es urgencia falsa, y eso ademas de
   enganar esta perseguido por la FTC. */
(function () {
  'use strict';

  var CLAVE = 'strapion_promo_v1';
  var caja = document.querySelector('[data-sp-promo]');
  if (!caja) return;

  var codigo = (caja.getAttribute('data-codigo') || '').trim();
  var fin = new Date(caja.getAttribute('data-fin'));
  var retraso = (Number(caja.getAttribute('data-retraso')) || 0) * 1000;
  var aviso = document.querySelector('[data-sp-nudge]');
  if (!codigo || isNaN(fin.getTime())) return;

  /* Dos memorias, porque son dos casos distintos.

     "Descartado" vive en sessionStorage: dentro de la misma visita no vuelve a
     salir, ni al navegar al configurador ni a un producto. Al cerrar el
     navegador se borra, asi que en una visita nueva reaparece.

     "Aceptado" vive en localStorage y es permanente: a quien ya aplico el
     codigo no se le vuelve a ofrecer, porque ya lo tiene puesto. */
  function leer() {
    try {
      if (localStorage.getItem(CLAVE) === 'aceptado') return 'aceptado';
      return sessionStorage.getItem(CLAVE);
    } catch (e) {
      return null;
    }
  }

  function guardar(v) {
    try {
      if (v === 'aceptado') localStorage.setItem(CLAVE, v);
      else sessionStorage.setItem(CLAVE, v);
    } catch (e) { /* navegacion privada */ }
  }

  /* --- cuenta atras --------------------------------------------------- */

  /* Por encima de un dia se cuentan dias y horas: "94:00:33" no se lee como
     tiempo, se lee como un numero raro. Por debajo, reloj al segundo, que es
     donde la cuenta atras aprieta de verdad. */
  function restante() {
    var ms = fin.getTime() - Date.now();
    if (ms <= 0) return null;
    function dd(n) { return (n < 10 ? '0' : '') + n; }
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    if (h >= 24) {
      var dias = Math.floor(h / 24);
      return dias + 'd ' + (h % 24) + 'h ' + dd(m) + 'm';
    }
    return dd(h) + ':' + dd(m) + ':' + dd(s);
  }

  var temporizador;
  function tic() {
    var texto = restante();
    if (!texto) {
      window.clearInterval(temporizador);
      cerrar();
      if (aviso) aviso.hidden = true;
      return;
    }
    var relojes = document.querySelectorAll('[data-sp-reloj]');
    Array.prototype.forEach.call(relojes, function (e) { e.textContent = texto; });
  }

  /* --- popup ----------------------------------------------------------- */

  function abrir() {
    caja.hidden = false;
    // dos cuadros para que la transicion arranque desde el estado inicial
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { caja.classList.add('is-visible'); });
    });
    document.addEventListener('keydown', porEscape);
  }

  function cerrar() {
    caja.classList.remove('is-visible');
    document.removeEventListener('keydown', porEscape);
    window.setTimeout(function () { caja.hidden = true; }, 240);
  }

  function porEscape(e) {
    if (e.key === 'Escape') { guardar('descartado'); cerrar(); pintarAviso(); }
  }

  function aplicar() {
    guardar('aceptado');
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var vuelta = location.pathname + location.search;
    location.href = raiz + 'discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(vuelta);
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-sp-cerrar]'), function (b) {
    b.addEventListener('click', function () { guardar('descartado'); cerrar(); pintarAviso(); });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-sp-aplicar]'), function (b) {
    b.addEventListener('click', aplicar);
  });

  /* --- aviso del carrito ------------------------------------------------ */

  /* No basta con lo que diga localStorage: si el codigo ya esta puesto en el
     carrito, el aviso sobra aunque el visitante nunca pulsase el boton. */
  function pintarAviso() {
    if (!aviso) return;
    if (leer() === 'aceptado') { aviso.hidden = true; return; }

    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        var puesto = (carrito.discount_codes || []).some(function (d) {
          return String(d.code).toLowerCase() === codigo.toLowerCase();
        });
        if (puesto) { guardar('aceptado'); aviso.hidden = true; return; }
        if (carrito.item_count === 0) { aviso.hidden = true; return; }

        if (!aviso.childNodes.length) {
          var titulo = caja.getAttribute('data-carrito-titulo') || '';
          var boton = caja.getAttribute('data-carrito-boton') || 'Apply';
          var t = document.createElement('span');
          t.className = 'sp-nudge__texto';
          t.innerHTML = '<strong></strong><span></span>';
          t.querySelector('strong').textContent = titulo;
          t.querySelector('span').textContent = codigo + ' · ' + (restante() || '') + ' left';
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sp-nudge__cta';
          b.textContent = boton;
          b.addEventListener('click', aplicar);
          aviso.appendChild(t);
          aviso.appendChild(b);
        }
        aviso.hidden = false;
      })
      .catch(function () { /* sin carrito no hay aviso que dar */ });
  }

  /* --- arranque --------------------------------------------------------- */

  if (!restante()) return; // la oferta ya caduco

  tic();
  temporizador = window.setInterval(tic, 1000);
  pintarAviso();

  // Una vez por visita: si ya lo cerro o lo aplico, no reaparece al navegar.
  if (!leer()) window.setTimeout(abrir, retraso);
})();
